<div class="flex items-center justify-center w-full h-full">
	<ng-lottie [options]="options" (animationCreated)="onAnimate($event)"></ng-lottie>
</div>
